
<template>
  <div class="invoice-index-page invoices main-content">
    <div class="page-header">
      <h3 class="page-title"> {{ $t('navigation.bulk_processing') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="dashboard">
            {{ $t('general.home') }}
          </router-link>
        </li>
        <li class="breadcrumb-item" >
          <router-link
            slot="item-title"
            to="#">
            {{ $t('navigation.bulk_processing') }}
          </router-link>
        </li>
      </ol>
    </div>
    <div class="settings-container">
        <div class="setting-card">
            <div class="setting-main-container">
                <form action="" id="form" @submit.prevent="updateUserData">
                <div class="card setting-card">
                    <div class="page-header">
                        <h3 class="page-title">{{ $t('navigation.assign_bulk_processing') }}</h3>
                        <p class="page-sub-title">
                            {{ $t('navigation.bulk_processing_info') }}
                        </p>
                    </div>

                    <div class="row">

                        <div class="col-md-4 mb-4 form-group">
                          <multiselect v-model="selected_suppliers" :options="suppliers" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="contact_name" track-by="contact_name" :preselect-first="true">

                          </multiselect>

                        </div>
                        <div class="col-md-4 mb-4 form-group">
                          <multiselect v-model="selected_buyers" :options="buyers" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="contact_name" track-by="contact_name" :preselect-first="true">

                          </multiselect>

                        </div>

                        <div class="col-md-4 mb-4 form-group">
                          <multiselect v-model="selected_funders" :options="funders" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="contact_name" track-by="contact_name" :preselect-first="true">

                          </multiselect>

                        </div>

                        <div class="col-md-4 mb-4 form-group">
                            <label class="input-label">{{ $tc('payments.start_range') }}</label>
                            <input type="number" class="form-control" v-model="s_range">
                            <!-- <select class="form-control" v-model="s_range">
                                <option v-for="amount in amount_range" :key="amount.value" :value="amount.value">{{amount.value}}</option>
                            </select> -->
                            <!-- <input class="form-control" type="text" v-model="formData.buyer"> -->
                        </div>

                        <div class="col-md-4 mb-4 form-group">
                            <label class="input-label">{{ $tc('payments.end_range') }}</label>
                            <input type="number" class="form-control" v-model="e_range">
                            <!-- <select name="" class="form-control" v-model="e_range">
                                <option v-for="amount in amount_range" :key="amount.value" :value="amount.value">{{amount.value}}</option>
                            </select> -->
                            <!-- <input class="form-control" type="text" v-model="formData.funder"> -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 mb-4 form-group">
                            <label class="input-label">{{ $tc('payments.start_days') }}</label>
                            <input type="number" class="form-control" v-model="start_days">
                        </div>

                         <div class="col-md-4 mb-4 form-group">
                            <label class="input-label">{{ $tc('payments.end_days') }}</label>
                            <input type="number" class="form-control" v-model="end_days">
                        </div>

                    </div>

                    <div class="row  mb-4">
                      <div class="col-md-12 input-group">
                          <base-button
                          icon="save"
                          color="theme"
                          type="submit"
                          >
                          {{ $tc('settings.account_settings.save') }}
                          </base-button>
                      </div>
                    </div>
                </div>
                </form>
            </div>
        </div>
    </div>

  </div>

</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import Swal from 'sweetalert2';
// const { required } = require('vuelidate/lib/validators')
export default {
  components: {
    Multiselect
  },
    data () {

        return {
            formData:{
                supplier  : null,
                buyer  : null,
                funder   : null,
                // multiSelect: ['one', 'three']
            },
            amount_range:[
            { value: '1000', name: '1000' },
            { value: '2000', name: '2000' },
            { value: '3000', name: '3000' },
            { value: '4000', name: '4000' },
            { value: '5000', name: '5000' },
            ],
            suppliers : [],
            buyers : [],
            funders : [],
            selected_suppliers : [],
            selected_buyers : [],
            selected_funders : [],
            range_date : '',
            start_days : '',
            end_days : '',
            s_range : '',
            e_range : '',
        }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData:function(){
        axios.get('/api/bulk-process').then(res=>{
        if(res.status==200){
            this.buyers = res.data.buyers;
            this.suppliers = res.data.suppliers;
            this.funders = res.data.funders;
            this.range_date = res.data.range_date;
            this.selected_suppliers = res.data.selected_suppliers;
            this.selected_buyers = res.data.selected_buyers;
            this.selected_funders = res.data.selected_funders;
            this.range_date = res.data.range_date;

            this.start_days = res.data.range_date.start_days;
            this.end_days = res.data.range_date.end_days;
            this.s_range = res.data.range_date.start_range;
            this.e_range = res.data.range_date.end_range;
            console.log(this.range);
        }
        }).catch(err=>{
            console.log(err)
        });
      },

      updateUserData:function(){
        let sup_ids = [];
        let buy_ids = [];
        let fun_ids = [];
        if(this.selected_suppliers){
          this.selected_suppliers.map(function(x){
            sup_ids.push(x.id);
          });
        }

        if(this.selected_buyers){
          this.selected_buyers.map(function(x){
            buy_ids.push(x.id);
          });
        }
        if(this.selected_funders){
          this.selected_funders.map(function(x){
            fun_ids.push(x.id);
          });
        }

        let sup_ids_str = sup_ids.toString();
        let buy_ids_str = buy_ids.toString();
        let fun_ids_str = fun_ids.toString();

        axios.post('/api/update-bulk-process',{
          s_range : this.s_range,
          e_range : this.e_range,
          s_days : this.start_days,
          e_days : this.end_days,
          sup : sup_ids_str,
          buy : buy_ids_str,
          fun : fun_ids_str
        })
        .then(res=>{
          if(res.status==200){
            Swal.fire(
            'Form submitted successfully!',
            'Thank You!',
            'success'
            )
          }else{
            Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!'
            })
          }
        }).catch(err=>{
          console.log(err)
        });
      }
    }
}

</script>
